import emojis from "@/components/markdown/view/data/emojis";
import { visit } from "unist-util-visit";

export default function emojisRehype() {
    return (tree: any) => {
        visit(tree, "text", (node: any, index: number | undefined, parent: any) => {
            const regex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]|<:[A-Za-z0-9_-]+:[A-Za-z0-9_-]+>)/g;
            
            if (regex.test(node.value)) {
                const parts = node.value.split(regex);
                const newNode = {
                    type: "element",
                    tagName: "span",
                    properties: {},
                    children: [] as any[],
                };

                parts.forEach((part: any, idx: any) => {
                    if (idx % 2 === 0) {
                        newNode.children.push({
                            type: "text",
                            value: part,
                        });
                    } else {
                        const emojiData = emojis.find((emoji: any) => emoji.emoji === part)
                        if (emojiData || part.match(/<:[a-zA-Z0-9_-]+:[a-zA-Z0-9]+>/)) {
                            newNode.children.push({
                                type: "element",
                                tagName: "emoji",
                                properties: { className: "emoji" },
                                children: [{ type: "text", value: emojiData?.emoji||part }],
                            });
                        } else {
                            newNode.children.push({
                                type: "text",
                                value: part,
                            });
                        }
                    }
                });

                parent.children[index!] = newNode;
            }
        });
    };
}
